import { EventHandler } from "./events";


export interface Module
{
    id: string;
    children: Module[];
    exports: any;
    require: (id: string) => any;
}


export interface ModuleManagement
{
    getMainModule(): Module;
    getModuleId(module: Module): string;
    getModule(id: string): Module;
    getModules(): Module[];
    getExportModules($export: object): Module[];
    on(event: Event, handler: EventHandler<Module>): this;
    off(event: Event, handler: EventHandler<Module>): this;
}


export namespace Module
{
    export let getMainModule: ModuleManagement["getMainModule"];
    export let getModuleId: ModuleManagement["getModuleId"];
    export let getModule: ModuleManagement["getModule"];
    export let getModules: ModuleManagement["getModules"];
    export let getExportModules: ModuleManagement["getExportModules"];
    export let on: ModuleManagement["on"];
    export let off: ModuleManagement["off"];


    if (process.env.WEBPACK)
    {
        const webpackModule = require("./webpack/module") as typeof import("./webpack/module");
        Object.assign(Module, webpackModule.Module);
    }
    else
    {
        const nodeModule = require("./node/module") as typeof import("./node/module");
        Object.assign(Module, nodeModule.Module);
    }
}


export type Event = "load";
